'use strict';

var addressHelpers = require('./address');
var cleave = require('../components/cleave');
var formHelpers = require('./formErrors');

var cachedBillingAddress = null;
var hasAutoUncheckedPayPalMismatch = false;

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#shippingAddressValidationModal').length !== 0) {
        $('#shippingAddressValidationModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div data-private="lipsum" class="modal fade" id="shippingAddressValidationModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog modal--added-by-js">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <h4 class="modal-title--bigger text-center">Verify your address</h4>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}
/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {Object} e - data from the suggestion modal
 * @returns {Object} -promise
 */
function addressSelection(e) {
    var data = e.data.param;
    var deferred = e.data.defer;
    var url = data.updateUrl;
    var $billingForm = e.data.form;
    var check = $('input[name=verifyaddress]:checked').val();
    if (check === 'notfound-address') {
        $('#shippingAddressValidationModal').modal('hide');
        $('.modal-backdrop').hide();
        var isExpressCheckout = $('.express-checkout').length > 0;
        if (isExpressCheckout) {
            $('#editBillingAddressModal').modal('show');
        } else {
            $('.payment-summary .edit-button', '#checkout-main').trigger('click');
        }
        return deferred.resolve();
    }
    if (check === 'entered-address') {
        $('.billingAddressOne').val(data.enteredAddress.street);
        if (data.enteredAddress.street2) {
            $('.billingAddressTwo').val(data.enteredAddress.street2);
        }
        $('.billingAddressCity').val(data.enteredAddress.city);
        $('.billingState').val(data.enteredAddress.state).change();
        $('.billingZipCode').val(data.enteredAddress.zipcode);
        var form = $billingForm.serializeArray();
        $('#shippingAddressValidationModal').modal('hide');
        $('.modal-backdrop').hide();
        form.push({
            name: 'addressId',
            value: data.addressId
        },
            {
                name: 'enteredAddressStreet',
                value: data.enteredAddress.street
            });
        return $.ajax({
            url: url,
            method: 'POST',
            data: form,
            success: function (response) {
                if (response.error) {
                    window.location.href = response.redirectUrl;
                } else {
                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: response.order,
                            customer: response.customer
                        });
                }
                return deferred.resolve();
            }
        });
    }
    if (check === 'suggested-address') {
        $('.billingAddressOne').val(data.suggestedAddress.street);
        $('.billingAddressTwo').val(data.suggestedAddress.street2);
        $('.billingAddressCity').val(data.suggestedAddress.city);
        $('.billingState').val(data.suggestedAddress.state).change();
        $('.billingZipCode').val(data.suggestedAddress.zipcode);
        $('#shippingAddressValidationModal').modal('hide');
        $('.modal-backdrop').hide();
        var forms = $billingForm.serializeArray();
        forms.push({
            name: 'addressId',
            value: data.addressId
        },
            {
                name: 'suggestedAddressStreet',
                value: data.suggestedAddress.street
            },
            {
                name: 'smartyRDI',
                value: data.responseAddressData.metadata.rdi
            });
        return $.ajax({
            url: url,
            method: 'POST',
            data: forms,
            success: function (response) {
                if (response.error) {
                    window.location.href = response.redirectUrl;
                } else {
                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: response.order,
                            customer: response.customer
                        });
                }
                return deferred.resolve();
            }
        });
    }
    return deferred.resolve();
}

/**
 * smarty street adress suggestion
 * @param {Object} form - billing form
 * @returns {Object} promise
 */
function addressSuggestion(form) {
    var defer = $.Deferred(); // eslint-disable-line
    var adressSuggestionUrl = $('#checkout-submit-payment').attr('data-url') || $('.update-billing-address').data('url');
    $('#shippingAddressValidationModal').spinner().start();
    return $.ajax({
        url: adressSuggestionUrl,
        method: 'GET',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            if (data.error) {
                defer.resolve(data);
            } else if (!data.smartyStreetVerification && data.success) {
                defer.resolve(data);
            } else if (!data.isSmartyValidated && !data.isSmartyValidationBypassed) {
                if ($('.enableSmartyStreetsAutoComplete').data('enablesmartystreetsautocomplete') && (window.sessionStorage.getItem('billing') === 'true' || (data.billingSameAsShipping && window.sessionStorage.getItem('shipping') === 'true'))) {
                    defer.resolve(data);
                } else {
                    getModalHtmlElement();
                    $('#editBillingAddressModal').modal('hide');
                    $('#shippingAddressValidationModal .modal-body').empty();
                    $('#shippingAddressValidationModal .modal-body').html(data.renderedTemplate);
                    $('#shippingAddressValidationModal .modal-header .close .sr-only').text(data.closeButtonText);
                    $('#shippingAddressValidationModal').modal('show');
                    $('#shippingAddressValidationModal').spinner().stop();
                    $('.selectedAdress').click({ param: data, defer: defer, form: form }, addressSelection);
                }
            }
            return defer.resolve();
        }
    });
}

/**
 * updates the billing address selector within billing forms
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateBillingAddressSelector(order, customer) {
    var shippings = order.shipping;

    var form = $('form[name$=billing]')[0];
    var $billingAddressSelector = $('.addressSelector', form);
    var hasSelectedAddress = false;

    if ($billingAddressSelector && $billingAddressSelector.length === 1) {
        $billingAddressSelector.empty();
        // Add New Address option
        $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            null,
            false,
            order,
            { type: 'billing' }));

        // Separator -
        $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            order.resources.shippingAddresses, false, order, {
                // className: 'multi-shipping',
                type: 'billing'
            }
        ));

        shippings.forEach(function (aShipping) {
            var isSelected = order.billing.matchingAddressId === aShipping.UUID;
            hasSelectedAddress = hasSelectedAddress || isSelected;
            // Shipping Address option
            $billingAddressSelector.append(
                addressHelpers.methods.optionValueForAddress(aShipping, isSelected, order,
                    {
                        // className: 'multi-shipping',
                        type: 'billing'
                    }
                )
            );
        });

        if (customer.addresses && customer.addresses.length > 0) {
            $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.accountAddresses, false, order));
            customer.addresses.forEach(function (address) {
                var isSelected = order.billing.matchingAddressId === address.ID;
                hasSelectedAddress = hasSelectedAddress || isSelected;
                // Customer Address option
                $billingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress({
                        UUID: 'ab_' + address.ID,
                        shippingAddress: address
                    }, isSelected, order, { type: 'billing' })
                );
            });
        }
    }

    if (hasSelectedAddress
        || (!order.billing.matchingAddressId && order.billing.billingAddress.address)) {
        // show
        $(form).attr('data-address-mode', 'edit');
    } else {
        $(form).attr('data-address-mode', 'new');
    }

    $billingAddressSelector.show();
}

/**
 * Get a shipping address form field value by suffix
 * @param {string} fieldSuffix - shipping form field suffix
 * @returns {string} field value or empty string
 */
function getShippingFormFieldValue(fieldSuffix) {
    var $field = $('[name$=_shippingAddress_addressFields_' + fieldSuffix + '], [name$=_shippingAddress_addressFields_states_' + fieldSuffix + ']').first();
    if (!$field.length) {
        $field = $('[name$=_shippingAddress_addressFields_shipping' + fieldSuffix.charAt(0).toUpperCase() + fieldSuffix.slice(1) + ']').first();
    }
    return $field.length ? $field.val() : '';
}

/**
 * Cache the current billing form values for later restore
 */
function cacheBillingAddressFromForm() {
    var form = $('form[name=dwfrm_billing]');
    if (!form.length) {
        return;
    }

    var countryCode = $('select[name$=_country]', form).val();
    cachedBillingAddress = {
        firstName: $('input[name$=_firstName]', form).val() || '',
        lastName: $('input[name$=_lastName]', form).val() || '',
        address1: $('input[name$=_address1]', form).val() || '',
        address2: $('input[name$=_address2]', form).val() || '',
        city: $('input[name$=_city]', form).val() || '',
        postalCode: $('input[name$=_postalCode]', form).val() || '',
        companyName: $('input[name$=_companyName]', form).val() || '',
        phone: $('input[name$=_phone]', form).val() || '',
        countryCode: { value: countryCode || '' },
        stateCode: $('#billingState').val() || $('select[name$=_stateCode]', form).val() || '',
        provinceCode: $('#province').val() || $('select[name$=_provinceCode]', form).val() || '',
        nonusstate: $('#nonusstate').val() || $('input[name$=_nonusstate]', form).val() || ''
    };
}

/**
 * Toggle US / CA / non-US billing region fields by country
 * @param {string} countryCode - billing country code
 */
function applyBillingCountryFieldVisibility(countryCode) {
    var $form = $('#dwfrm_billing');
    if (countryCode === 'US') {
        $form.find('.non-us-states').addClass('d-none');
        $form.find('.ca-province').addClass('d-none');
        $form.find('.us-states').removeClass('d-none');
    } else if (countryCode === 'CA') {
        $form.find('.us-states').addClass('d-none');
        $form.find('.non-us-states').addClass('d-none');
        $form.find('.ca-province').removeClass('d-none');
    } else if (countryCode) {
        $form.find('.us-states').addClass('d-none');
        $form.find('.ca-province').addClass('d-none');
        $form.find('.non-us-states').removeClass('d-none');
    }
}

/**
 * Set billing state / province / non-US region fields from an address
 * @param {Object} form - jQuery billing form
 * @param {string} countryCode - billing country code
 * @param {Object} address - address with region fields
 */
function setBillingRegionFields(form, countryCode, address) {
    if (countryCode === 'US') {
        $('#billingState, select[name$=_stateCode]', form).val(address.stateCode || '');
    } else if (countryCode === 'CA') {
        $('#province, select[name$=_provinceCode]', form).val(address.provinceCode || address.stateCode || '');
    } else {
        $('#nonusstate, input[name$=_nonusstate]', form).val(address.nonusstate || address.stateCode || '');
    }
}

/**
 * Copy an address object into the billing form fields
 * @param {Object} address - address model
 */
function copyAddressObjectToBillingForm(address) {
    var form = $('form[name=dwfrm_billing]');
    if (!form.length || !address) {
        return;
    }

    var countryCode = address.countryCode && address.countryCode.value ? address.countryCode.value : address.countryCode;

    $('input[name$=_firstName]', form).val(address.firstName || '');
    $('input[name$=_lastName]', form).val(address.lastName || '');
    $('input[name$=_address1]', form).val(address.address1 || '');
    $('input[name$=_address2]', form).val(address.address2 || '');
    $('input[name$=_city]', form).val(address.city || '');
    $('input[name$=_postalCode]', form).val(address.postalCode || '');
    $('input[name$=_companyName]', form).val(address.companyName || '');
    if (countryCode) {
        $('#billingCountry, select[name$=_country]', form).val(countryCode);
        applyBillingCountryFieldVisibility(countryCode);
    }
    setBillingRegionFields(form, countryCode, address);
    if (address.phone) {
        $('input[name$=_phone]', form).val(address.phone);
    }
}

/**
 * Copy shipping address form values into the billing form
 * @param {Object} form - jQuery billing form
 */
function copyShippingtoBillingForm(form) {
    var shippingCountry = getShippingFormFieldValue('shippingCountry') || getShippingFormFieldValue('country');
    var shippingState = getShippingFormFieldValue('stateCode');
    $('input[name$=_firstName]', form).val(getShippingFormFieldValue('firstName'));
    $('input[name$=_lastName]', form).val(getShippingFormFieldValue('lastName'));
    $('input[name$=_address1]', form).val(getShippingFormFieldValue('address1'));
    $('input[name$=_address2]', form).val(getShippingFormFieldValue('address2'));
    $('input[name$=_city]', form).val(getShippingFormFieldValue('city'));
    $('input[name$=_postalCode]', form).val(getShippingFormFieldValue('postalCode'));
    $('input[name$=_companyName]', form).val(getShippingFormFieldValue('companyName'));
    $('input[name$=_phone]', form).val(getShippingFormFieldValue('phone'));
    if (shippingCountry) {
        $('#billingCountry, select[name$=_country]', form).val(shippingCountry);
        applyBillingCountryFieldVisibility(shippingCountry);
    }
    setBillingRegionFields(form, shippingCountry, {
        stateCode: shippingState,
        provinceCode: getShippingFormFieldValue('provinceCode') || shippingState,
        nonusstate: getShippingFormFieldValue('nonusstate') || shippingState
    });
}

/**
 * Copy shipping address from order model into billing form fields
 * @param {Object} order - checkout order model
 */
function copyShippingToBillingFromOrder(order) {
    var form = $('form[name=dwfrm_billing]');
    var shipping = order.shipping && order.shipping[0] && order.shipping[0].shippingAddress;
    if (!form.length || !shipping) {
        copyShippingtoBillingForm(form);
        return;
    }

    $('input[name$=_firstName]', form).val(shipping.firstName);
    $('input[name$=_lastName]', form).val(shipping.lastName);
    $('input[name$=_address1]', form).val(shipping.address1);
    $('input[name$=_address2]', form).val(shipping.address2 || '');
    $('input[name$=_city]', form).val(shipping.city);
    $('input[name$=_postalCode]', form).val(shipping.postalCode);
    $('input[name$=_companyName]', form).val(shipping.companyName || '');
    var shippingCountry = shipping.countryCode && shipping.countryCode.value;
    if (shippingCountry) {
        $('#billingCountry, select[name$=_country]', form).val(shippingCountry);
        applyBillingCountryFieldVisibility(shippingCountry);
    }
    setBillingRegionFields(form, shippingCountry, shipping);
    if (shipping.phone) {
        $('input[name$=_phone]', form).val(shipping.phone);
    }
}

/**
 * Copy billing address from order model into billing form fields
 * @param {Object} order - checkout order model
 */
function copyBillingToBillingForm(order) {
    var form = $('form[name=dwfrm_billing]');
    var billing = order.billing && order.billing.billingAddress && order.billing.billingAddress.address;
    if (!form.length || !billing) {
        return;
    }

    $('input[name$=_firstName]', form).val(billing.firstName);
    $('input[name$=_lastName]', form).val(billing.lastName);
    $('input[name$=_address1]', form).val(billing.address1);
    $('input[name$=_address2]', form).val(billing.address2 || '');
    $('input[name$=_city]', form).val(billing.city);
    $('input[name$=_postalCode]', form).val(billing.postalCode);
    $('input[name$=_companyName]', form).val(billing.companyName || '');
    var billingCountry = billing.countryCode && billing.countryCode.value;
    if (billingCountry) {
        $('#billingCountry, select[name$=_country]', form).val(billingCountry);
        applyBillingCountryFieldVisibility(billingCountry);
    }
    setBillingRegionFields(form, billingCountry, billing);
    if (billing.phone) {
        $('input[name$=_phone]', form).val(billing.phone);
    }
}

/**
 * Country code from an address model
 * @param {Object} address - address model
 * @returns {string} country code
 */
function getAddressCountryCode(address) {
    if (!address || !address.countryCode) {
        return '';
    }
    return address.countryCode.value || address.countryCode;
}

/**
 * Region value used to compare addresses
 * @param {Object} address - address model
 * @param {string} countryCode - country code
 * @returns {string} state, province, or non-US region
 */
function getAddressRegion(address, countryCode) {
    if (!address) {
        return '';
    }
    if (countryCode === 'CA') {
        return address.provinceCode || address.stateCode || '';
    }
    if (countryCode === 'US') {
        return address.stateCode || '';
    }
    return address.nonusstate || address.stateCode || '';
}

/**
 * Normalized address field value for comparison
 * @param {string} value - raw field value
 * @returns {string} trimmed lowercase value
 */
function normalizeAddressValue(value) {
    return (value || '').toString().trim().toLowerCase();
}

/**
 * Whether shipping and billing addresses match for same-as-shipping
 * @param {Object} shippingAddress - shipping address
 * @param {Object} billingAddress - billing address
 * @returns {boolean} true when the addresses match
 */
function isAddressSameForBilling(shippingAddress, billingAddress) {
    var shippingCountryCode = getAddressCountryCode(shippingAddress);
    var billingCountryCode = getAddressCountryCode(billingAddress);
    return normalizeAddressValue(shippingAddress && shippingAddress.firstName) === normalizeAddressValue(billingAddress && billingAddress.firstName)
        && normalizeAddressValue(shippingAddress && shippingAddress.lastName) === normalizeAddressValue(billingAddress && billingAddress.lastName)
        && normalizeAddressValue(shippingAddress && shippingAddress.address1) === normalizeAddressValue(billingAddress && billingAddress.address1)
        && normalizeAddressValue(shippingAddress && shippingAddress.address2) === normalizeAddressValue(billingAddress && billingAddress.address2)
        && normalizeAddressValue(shippingAddress && shippingAddress.city) === normalizeAddressValue(billingAddress && billingAddress.city)
        && normalizeAddressValue(shippingAddress && shippingAddress.postalCode) === normalizeAddressValue(billingAddress && billingAddress.postalCode)
        && normalizeAddressValue(shippingCountryCode) === normalizeAddressValue(billingCountryCode)
        && normalizeAddressValue(getAddressRegion(shippingAddress, shippingCountryCode)) === normalizeAddressValue(getAddressRegion(billingAddress, billingCountryCode));
}

/**
 * Whether PayPal is the selected payment method
 * @param {Object} order - checkout order model
 * @returns {boolean} true when PayPal is selected
 */
function isPayPalPaymentSelected(order) {
    var instruments = order && order.billing && order.billing.payment && order.billing.payment.selectedPaymentInstruments;
    if (instruments && instruments.length) {
        return instruments.some(function (instrument) {
            return instrument && instrument.paymentMethod === 'PayPal';
        });
    }
    // Fallback for flows where selectedPaymentInstruments is not yet populated.
    return ($('.payment-information').data('payment-method-id') || '') === 'PayPal';
}

/**
 * Sync visible billing summary and hidden form fields with same-as-shipping checkbox state
 * @param {Object} order - checkout order model
 * @param {boolean} autoUncheckPayPalMismatch - uncheck once when PayPal billing differs from shipping
 */
function applySameAsShippingView(order, autoUncheckPayPalMismatch) {
    var $checkbox = $('#sameAsShipping');
    if (!$checkbox.length) {
        return;
    }

    var isChecked = $checkbox.is(':checked');
    var shippingAddress = order && order.shipping && order.shipping[0] && order.shipping[0].shippingAddress;
    var billingAddress = order && order.billing && order.billing.billingAddress && order.billing.billingAddress.address;
    var isPayPalSelected = isPayPalPaymentSelected(order);
    var isBillingShippingSame = shippingAddress && billingAddress && isAddressSameForBilling(shippingAddress, billingAddress);
    if (isBillingShippingSame) {
        hasAutoUncheckedPayPalMismatch = false;
    }
    if (isChecked && isPayPalSelected && shippingAddress && billingAddress && !isBillingShippingSame) {
        if (autoUncheckPayPalMismatch && !hasAutoUncheckedPayPalMismatch) {
            $checkbox.prop('checked', false);
            isChecked = false;
        }
        hasAutoUncheckedPayPalMismatch = true;
    }

    $('.billing-address-block').toggleClass('d-none', isChecked);
    $('.address-summary-wrapper').toggleClass('d-none', !isChecked);

    if (!isChecked) {
        $('form[name=dwfrm_billing]').attr('data-address-mode', 'edit');
    }

    if (isChecked) {
        if (shippingAddress) {
            addressHelpers.methods.populateAddressSummary('.address-summary-wrapper .address-summary', shippingAddress);
            copyShippingToBillingFromOrder(order);
        } else {
            copyShippingtoBillingForm($('form[name=dwfrm_billing]'));
            $('.address-summary-wrapper .address-summary').html($('.shipping-summary .address-summary').first().html());
        }
    } else if (billingAddress) {
        addressHelpers.methods.populateAddressSummary('.address-summary-wrapper .address-summary', billingAddress);
        copyBillingToBillingForm(order);
    } else if (cachedBillingAddress) {
        addressHelpers.methods.populateAddressSummary('.address-summary-wrapper .address-summary', cachedBillingAddress);
        copyAddressObjectToBillingForm(cachedBillingAddress);
    } else if ($('.payment-summary .billing .address-summary').length) {
        $('.address-summary-wrapper .address-summary').html($('.payment-summary .billing .address-summary').html());
        cacheBillingAddressFromForm();
    }
}

/**
 * Ensure billing form hidden fields match checkbox state before payment submit
 * @param {Object} order - checkout order model
 */
function prepareBillingFormForSubmit(order) {
    if (!$('#sameAsShipping').length) {
        return;
    }

    if ($('#sameAsShipping').is(':checked')) {
        if (order) {
            copyShippingToBillingFromOrder(order);
        } else {
            copyShippingtoBillingForm($('form[name=dwfrm_billing]'));
        }
    }
}

/**
 * Updates the billing address form values within payment forms without any payment instrument validation
 * @param {Object} order - the order model
 */
function updateBillingAddress(order) {
    var billing = order.billing;
    if (!billing.billingAddress || !billing.billingAddress.address) return;

    var form = $('form[name=dwfrm_billing]');
    if (!form) return;
    if ($('#sameAsShipping').is(':checked')) {
        copyShippingToBillingFromOrder(order);
    } else {
        copyBillingToBillingForm(order);
    }
    $('input[name$=_email]', form).val(order.orderEmail);
}

/**
 * Validate and update payment instrument form fields
 * @param {Object} order - the order model
 */
function validateAndUpdateBillingPaymentInstrument(order) {
    var billing = order.billing;
    if (!billing.payment || !billing.payment.selectedPaymentInstruments
        || billing.payment.selectedPaymentInstruments.length <= 0) return;

    var form = $('form[name=dwfrm_billing]');
    if (!form) return;

    var instrument = billing.payment.selectedPaymentInstruments[0];
    if (instrument.paymentMethod !== 'ON_ACCOUNT' &&
  !$(document.activeElement).closest('form[name=dwfrm_billing]').length) {
        // Force all fields to clear
        $('select[name$=expirationMonth]', form).val('');
        $('select[name$=expirationYear]', form).val('');
        $('input[name$=securityCode]', form).val('');
        $('input[name$=cardNumber]').data('cleave').setRawValue('');
    }
}

/**
 * Updates the billing address form values within payment forms
 * @param {Object} order - the order model
 */
function updateBillingAddressFormValues(order) {
    module.exports.methods.updateBillingAddress(order);
    module.exports.methods.validateAndUpdateBillingPaymentInstrument(order);
}

/**
 * clears the billing address form values
 */
function clearBillingAddressFormValues() {
    $('.non-us-states').addClass('d-none');
    $('.ca-province').addClass('d-none');
    $('.us-states').removeClass('d-none');
    $('#province').val('OTHER');
    $('#billingState').val('');
    updateBillingAddressFormValues({
        billing: {
            billingAddress: {
                address: {
                    countryCode: { value: 'US' }
                }
            }
        }
    });
}

/**
 * Sync same-as-shipping checkbox and billing view from order addresses
 * @param {Object} order - checkout order model
 */
function syncSameAsShippingCheckbox(order) {
    if (!cachedBillingAddress) {
        cacheBillingAddressFromForm();
    }
    if (!order) {
        return;
    }
    applySameAsShippingView(order, true);
}

/**
 * Initialize same-as-shipping view from order on page load
 * @param {Object} order - checkout order model
 */
function initSameAsShippingView(order) {
    if (!cachedBillingAddress) {
        cacheBillingAddressFromForm();
    }
    applySameAsShippingView(order, true);
}

/**
 * update billing address summary and contact information
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updateBillingAddressSummary(order) {
    var billingAddress;
    if ($('#sameAsShipping').length && $('#sameAsShipping').is(':checked')
        && order.shipping && order.shipping[0] && order.shipping[0].shippingAddress) {
        billingAddress = order.shipping[0].shippingAddress;
    } else if (order.billing.billingAddress && order.billing.billingAddress.address) {
        billingAddress = order.billing.billingAddress.address;
    }
    if (!billingAddress) {
        return;
    }
    addressHelpers.methods.populateAddressSummary('.billing .address-summary', billingAddress);
    if (billingAddress.countryCode && billingAddress.countryCode.value === 'CA' && billingAddress.provinceCode) {
        $('.billing .address-summary .stateCode').text(billingAddress.provinceCode || '');
    } else if (billingAddress.countryCode && billingAddress.countryCode.value === 'US' && billingAddress.stateCode) {
        $('.billing .address-summary .stateCode').text(billingAddress.stateCode || '');
    } else {
        $('.billing .address-summary .stateCode').text(billingAddress.nonusstate || billingAddress.stateCode || '');
    }
}

/**
 * Updates the billing information in checkout, based on the supplied order model
 * @param {Object} order - checkout model to use as basis of new truth
 * @param {Object} customer - customer model to use as basis of new truth
 * @param {Object} [options] - options
 */
function updateBillingInformation(order, customer) {
    syncSameAsShippingCheckbox(order);
    updateBillingAddressSelector(order, customer);

    // update billing address form
    updateBillingAddressFormValues(order);

    // update billing address summary and billing parts of order summary
    updateBillingAddressSummary(order);
}

/**
 * Updates the payment information in checkout, based on the supplied order model
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updatePaymentInformation(order) {
    // update payment details
    var $paymentSummary = $('.payment-details');
    var htmlToAppend = '';
    var $giftCardSummary = $('.giftcard-details');
    var giftHtmlToAppend = '';
    if (order.billing.payment && order.billing.payment.selectedPaymentInstruments
        && order.billing.payment.selectedPaymentInstruments.length > 0) {
        var currencySymbol = $giftCardSummary.data('currency');
        var paymentInstruments = order.billing.payment.selectedPaymentInstruments;
        Object.keys(paymentInstruments).forEach(function (PI) {
            if (paymentInstruments[PI].paymentMethod === 'GIFT_CERTIFICATE') {
                giftHtmlToAppend += '<div class="mr-8"><span>' + order.resources.giftCardName + '</span><div>'
                    + paymentInstruments[PI].maskedGiftCertificateCode
                    + '</div><div><span class="font-weight-bold">'
                    + currencySymbol + paymentInstruments[PI].amount
                    + '</span></div></div>';
            }
            if (paymentInstruments[PI].paymentMethod === 'CREDIT_CARD') {
                var creditCardExpirationMonth = paymentInstruments[PI].expirationMonth;
                var month = (creditCardExpirationMonth < 10) ? '0' + creditCardExpirationMonth : creditCardExpirationMonth;
                var amount = (order.balanceAmount.formatted) ? order.balanceAmount.formatted : order.totals.grandTotal;
                htmlToAppend += '<span>' + order.resources.cardType + ' '
                    + paymentInstruments[PI].type
                    + '</span><div>'
                    + paymentInstruments[PI].maskedCreditCardNumber + ' '
                    + '<span>'
                    + order.resources.cardExp + ' '
                    + month
                    + '/' + paymentInstruments[PI].expirationYear
                    + '</span></div><div><span class="font-weight-bold">'
                    + amount + '</span></div>';
            }
            if (paymentInstruments[PI].paymentMethod === 'PayPal') {
                htmlToAppend += '<span>'
                    + paymentInstruments[PI].paypalEmail + '<br/>'
                    + (paymentInstruments[PI].isVenmoUsed ? 'Venmo' : paymentInstruments[PI].paymentMethod)
                    + '</span>';
            }
        });
    }
    $giftCardSummary.empty().append(giftHtmlToAppend);
    $paymentSummary.empty().append(htmlToAppend);
}

/**
 * clears the credit card form
 */
function clearCreditCardForm() {
    $('input[name$="_cardNumber"]').data('cleave').setRawValue('');
    $('select[name$="_expirationMonth"]').val('');
    $('select[name$="_expirationYear"]').val('');
    $('input[name$="_securityCode"]').val('');
}

module.exports = {
    methods: {
        addressSuggestion: addressSuggestion,
        updateBillingAddressSelector: updateBillingAddressSelector,
        updateBillingAddressFormValues: updateBillingAddressFormValues,
        clearBillingAddressFormValues: clearBillingAddressFormValues,
        updateBillingInformation: updateBillingInformation,
        updatePaymentInformation: updatePaymentInformation,
        clearCreditCardForm: clearCreditCardForm,
        updateBillingAddress: updateBillingAddress,
        validateAndUpdateBillingPaymentInstrument: validateAndUpdateBillingPaymentInstrument,
        updateBillingAddressSummary: updateBillingAddressSummary,
        syncSameAsShippingCheckbox: syncSameAsShippingCheckbox,
        applySameAsShippingView: applySameAsShippingView,
        prepareBillingFormForSubmit: prepareBillingFormForSubmit,
        initSameAsShippingView: initSameAsShippingView,
        cacheBillingAddressFromForm: cacheBillingAddressFromForm
    },

    initCOtooltips: function () {
        var tooltipOptions = {
            offset: '0, 20px',
            template: '<div class="tooltip checkout-tooltips" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
        };
        $('[data-toggle="tooltip"').tooltip(tooltipOptions);
    },

    showBillingDetails: function () {
        $('.btn-show-billing-details').on('click', function () {
            $(this).parents('[data-address-mode]').attr('data-address-mode', 'new');
        });
    },

    changeStateField: function () {
        $(document).on('change', '#billingCountry', function () {
            if ($(this).val() === 'US') {
                $('.non-us-states').addClass('d-none');
                $('.ca-province').addClass('d-none');
                $('.us-states').removeClass('d-none');
                $('#province').val('OTHER');
                $('.billingState').val('');
            } else if ($(this).val() === 'CA') {
                $('.us-states').addClass('d-none');
                $('.non-us-states').addClass('d-none');
                $('.ca-province').removeClass('d-none');
                $('.billingState').val('OTHER');
                $('#province').val('');
            } else {
                $('.us-states').addClass('d-none');
                $('.ca-province').addClass('d-none');
                $('.non-us-states').removeClass('d-none');
                $('#province').val('OTHER');
                $('.billingState').val('OTHER');
            }
        });
        $(document).on('change', '#billingAddressSelector', function () {
            var $billingForm = $('#dwfrm_billing');
            var otherCountry = ($('#billingCountry').val() !== 'US' && $('#billingCountry').val() !== 'CA');
            var isCA = ($('#billingCountry').val() === 'CA');
            var isUS = ($('#billingCountry').val() === 'US');
            if (isUS) {
                $billingForm.find('.non-us-states').addClass('d-none');
                $billingForm.find('.ca-province').addClass('d-none');
                $billingForm.find('.us-states').removeClass('d-none');
                $billingForm.find('#province').val('OTHER');
            } else if (isCA) {
                $billingForm.find('.us-states').addClass('d-none');
                $billingForm.find('.non-us-states').addClass('d-none');
                $billingForm.find('.ca-province').removeClass('d-none');
                $billingForm.find('.billingState').val('OTHER');
            } else if (otherCountry) {
                $billingForm.find('.ca-province').addClass('d-none');
                $billingForm.find('.us-states').addClass('d-none');
                $billingForm.find('.non-us-states').removeClass('d-none');
                $billingForm.find('.billingState').val('OTHER');
                $billingForm.find('#province').val('OTHER');
            }
        });
    },

    hideBillingDetails: function () {
        $('.btn-hide-billing-details').on('click', function () {
            $(this).parents('[data-address-mode]').attr('data-address-mode', 'shipment');
        });
    },

    selectBillingAddress: function () {
        $('.payment-form .addressSelector').on('change', function () {
            var form = $(this).parents('form')[0];
            var selectedOption = $('option:selected', this);
            var optionID = selectedOption[0].value;

            if (optionID === 'new') {
                // Show Address
                $(form).attr('data-address-mode', 'new');
            } else {
                // Hide Address
                $(form).attr('data-address-mode', 'shipment');
            }
            formHelpers.clearPreviousErrors(form);

            // Copy fields
            var attrs = selectedOption.data();
            var element;

            Object.keys(attrs).forEach(function (attr) {
                element = attr === 'countryCode' ? 'country' : attr;
                if (element === 'cardNumber') {
                    $('.cardNumber').data('cleave').setRawValue(attrs[attr]);
                } else {
                    $('[name$=' + element + ']', form).val(attrs[attr]);
                }
            });
        });
    },

    handleCreditCardNumber: function () {
        if ($('.cardNumber').length > 0) {
            cleave.handleCreditCardNumber('.cardNumber', '#cardType');
        }
    },

    santitizeForm: function () {
        $('body').on('checkout:serializeBilling', function (e, data) {
            var serializedForm = cleave.serializeData(data.form);

            data.callback(serializedForm);
        });
    },

    selectSavedPaymentInstrument: function () {
        $(document).on('click', '.saved-payment-instrument', function (e) {
            $('.saved-payment-instrument').attr('style', '');

            if (!$(e.target).closest('.save-credit-card').length) {
                e.preventDefault();
            }

            $('.selectedPaymentMethodRadio', $(this)).prop('checked', true);
            $('.saved-payment-instrument').removeClass('selected-payment');
            $(this).addClass('selected-payment');
            $('.saved-payment-instrument .card-image').removeClass('checkout-hidden');
            $('.saved-payment-instrument.selected-payment' +
                ' .card-image').addClass('checkout-hidden');
        });
    },

    addNewPaymentInstrument: function () {
        $('.add-payment').on('click', function (e) {
            e.preventDefault();
            $('.payment-information').data('is-new-payment', true);
            clearCreditCardForm();
            $('.credit-card-form').removeClass('checkout-hidden');
            $('.user-payment-instruments').addClass('checkout-hidden');
        });
    },

    cancelNewPayment: function () {
        $('.cancel-new-payment').on('click', function (e) {
            e.preventDefault();
            $('.payment-information').data('is-new-payment', false);
            clearCreditCardForm();
            $('.user-payment-instruments').removeClass('checkout-hidden');
            $('.credit-card-form').addClass('checkout-hidden');
        });
    },

    clearBillingForm: function () {
        $('body').on('checkout:clearBillingForm', function () {
            clearBillingAddressFormValues();
        });
    },

    paymentTabs: function () {
        $('.payment-options .nav-item').on('click', function (e) {
            e.preventDefault();
            if ($(this).is('.applepay-tab-wrapper')) {
                $('.checkout-workflow-buttons, .checkout-step-teaser.order-tease').hide();
            } else {
                $('.checkout-workflow-buttons, .checkout-step-teaser.order-tease').show();
            }
            var methodID = $(this).data('method-id');
            $('.payment-information').data('payment-method-id', methodID);
        });
    },

    sameAsShipping: function () {
        // Toggle handled in checkout.changeBillingView
    },

    storeBillingAddress: function () {
        var billingAddress = [];
        var form = $('form[name=dwfrm_billing]');
        if ($('#sameAsShipping').not(':checked')) {
            var isExpressCheckout = $('.express-checkout').length > 0;
            if (!isExpressCheckout) {
                $('.billingFirstName, .billingLastName, .billingAddressTwo, .billingAddressCity, .billingZipCode, .billingAddressOne, .billingState, .billingCountry, .billingCompanyName').change(function () {
                    var addressMode = $(form).attr('data-address-mode');
                    billingAddress = [
                        addressMode,
                        $('input[name$=_firstName]', form).val(),
                        $('input[name$=_lastName]', form).val(),
                        $('input[name$=_address1]', form).val(),
                        $('input[name$=_address2]', form).val(),
                        $('input[name$=_city]', form).val(),
                        $('input[name$=_postalCode]', form).val(),
                        $('input[name$=_companyName]', form).val(),
                        $('select[name$=_stateCode],input[name$=_stateCode]', form).val(),
                        $('select[name$=_country]', form).val()
                    ];
                    window.sessionStorage.setItem('billingAddress', billingAddress);
                });
            }
        }
    },

    onBillingAddressUpdate: function () {
        if ($('.enableSmartyStreetsAutoComplete').data('enablesmartystreetsautocomplete')) {
            $('.billingAddressTwo, .billingAddressCity, .billingZipCode').on('keyup', function () {
                window.sessionStorage.removeItem('billing');
            });
            $('.billingState').on('change', function () {
                window.sessionStorage.removeItem('billing');
            });
        }
    }
};
